import MultipleCard from '@activities/prepaidCard/MyPrepaidCardActivity/components/MultipleCard';
import Divider from '@components/Divider';
import Header from '@components/Header';
import Loading from '@components/Loading';
import PrepaidCardNotes from '@components/prepaid/PrepaidCardNotes';
import TermNotes from '@components/term/TermNotes';
import colors from '@constants/colors';
import SettingLine from '@icons/setting/SettingLine';
import { Link } from '@stackflow/link';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import Blank from './components/Blank';
import CardDetail from './components/CardDetail';
import useFavoritePrepaidCards from './hooks/useFavoritePrepaidCards';

declare module '@stackflow/config' {
    interface Register {
        MyPrepaidCardActivity: {};
    }
}

const MyPrepaidCardActivity: ActivityComponentType<'MyPrepaidCardActivity'> = () => {
    const { t } = useTranslation('prepaidCard');
    const { prepaidCards, isBlank, isLoading } = useFavoritePrepaidCards();
    return (
        <AppScreen>
            <Header title={t('title')}
                trailing={<Link activityParams={{}}
                    activityName='PrepaidCardManageActivity' >
                    <SettingLine color={colors.gray9} size={30} />
                </Link>}/>
            {isBlank && (
                <Blank/>
            )}
            {isLoading && (
                <Loading size='small' />
            )}
            {prepaidCards && (
                <MultipleCard cards={prepaidCards}
                    isBlank={isBlank} />
            )}
            {(!isBlank) && (
                <Fragment>
                    <CardDetail/>
                    <Divider/>
                </Fragment>
            )}
            <TermNotes displayContext='PREPAY' />
        </AppScreen>
    );
};

export default MyPrepaidCardActivity;
